/** @file Signup view. */
import { registerWithEmail, mapAuthError } from "../../persistence/auth.js";
import { navigate } from "../../core/router.js";
import { h, clear } from "../dom.js";

/**
 * @param {HTMLElement} host
 */
export function mountSignupView(host) {
  clear(host);
  const emailInput = h("input", {
    type: "email",
    name: "email",
    autocomplete: "email",
    required: true,
    class: "hb-auth-input",
  });
  const pwInput = h("input", {
    type: "password",
    name: "password",
    autocomplete: "new-password",
    required: true,
    minLength: 6,
    class: "hb-auth-input",
  });
  const pw2Input = h("input", {
    type: "password",
    name: "password2",
    autocomplete: "new-password",
    required: true,
    minLength: 6,
    class: "hb-auth-input",
  });
  const errorEl = h("div", { class: "text-sm text-red-400 min-h-5", role: "alert" });
  const submit = h("button", { type: "submit", class: "hb-btn hb-btn--primary min-h-11 mt-2" }, [
    "Konto erstellen",
  ]);
  const form = h("form", { class: "flex flex-col gap-3" }, [
    h("label", { class: "flex flex-col gap-1 text-sm" }, [h("span", null, ["E-Mail"]), emailInput]),
    h("label", { class: "flex flex-col gap-1 text-sm" }, [
      h("span", null, ["Passwort (min. 6 Zeichen)"]),
      pwInput,
    ]),
    h("label", { class: "flex flex-col gap-1 text-sm" }, [
      h("span", null, ["Passwort wiederholen"]),
      pw2Input,
    ]),
    submit,
    errorEl,
  ]);
  const loginLink = h("a", { href: "#/login", class: "text-blue-400 hover:text-blue-300" }, [
    "Einloggen",
  ]);
  const card = h(
    "div",
    {
      class:
        "hb-auth-card max-w-sm mx-auto mt-16 p-6 rounded-2xl bg-neutral-800 shadow-xl text-neutral-100",
    },
    [
      h("h1", { class: "text-2xl font-bold mb-4" }, ["Konto erstellen"]),
      form,
      h("div", { class: "mt-4 text-sm" }, [document.createTextNode("Bereits Konto? "), loginLink]),
    ],
  );
  host.appendChild(card);

  form.addEventListener("submit", async (e) => {
    e.preventDefault();
    errorEl.textContent = "";
    const pw = /** @type {HTMLInputElement} */ (pwInput).value;
    const pw2 = /** @type {HTMLInputElement} */ (pw2Input).value;
    if (pw !== pw2) {
      errorEl.textContent = "Passwörter stimmen nicht überein";
      return;
    }
    try {
      await registerWithEmail(/** @type {HTMLInputElement} */ (emailInput).value, pw);
      navigate("editor");
    } catch (err) {
      errorEl.textContent = mapAuthError(err);
    }
  });
}
